<template>
  <div class="bio-component card px-5 py-4">
    <div class="card-body bg-lightgray d-flex p-0 no-gutters align-items-center row">
      <div class="col-12 mb-4 mb-xl-0 col-xl-3 col-12 text-center">
        <img class="img-fluid" v-if="magidShiur.image" :src="magidShiur.image.url" :alt="magidShiur.name" width="200px" />
        <img class="img-fluid" v-else="magidShiur.image" src="/static/blank_profile.jpg" :alt="magidShiur.name" />
      </div>
      <div class="col-12 text-center text-xl-left col-xl-9 pr-xl-5">
        <h3 v-text="magidShiur.name" class="text-white"></h3>
        <div class="h5 text-white">({{ magidShiur.shiurim_count }} Shiurim)</div>

        <div v-html="magidShiur.bio" class="mt-2 magid-bio text-white"></div>
        <button
          v-if="type === 'torah'"
          @click="followSpeakerEvent"
          class="btn btn-secondary text-primary d-flex align-items-center text-white"
          v-b-tooltip.hover.right
          :title="$t('follow.tooltip')"
        >
          <span>
            <i class="fa fa-2x" :class="isSpeakerFollowed ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
          </span>
          <span class="ml-2 text-size-normal">{{ isSpeakerFollowed ? $_t('KW:unfollow') : $_t('KW:follow') }} {{ $_t('KW:speaker') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['magidShiur', 'type'],
  computed: {
    isSpeakerFollowed: function() {
      return this.$store.state.profile.followedSpeakers.some(save => {
        return save.id === this.magidShiur.id;
      });
    },
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'bio',
  },
  methods: {
    followSpeakerEvent() {
      if (!this.$store.getters['auth/isLoggedIn']) {
        this.$store.dispatch('auth/showModal');
        return;
      }
      if (this.isSpeakerFollowed) {
        this.unfollowSpeakerForUser();
      } else {
        this.followSpeakerForUser();
      }
    },
    followSpeakerForUser() {
      this.$http.post('/api/user/follow-speaker/' + this.magidShiur.id).then(response => {
        let followedSpeakers = this.$store.state.profile.followedSpeakers;
        followedSpeakers.push(response.data);
        this.$store.dispatch('profile/loadFollowingSpeakers', followedSpeakers);
      });
    },
    unfollowSpeakerForUser() {
      this.$http.post('/api/user/unfollow-speaker/' + this.magidShiur.id).then(response => {
        let followedSpeakers = this.$store.state.profile.followedSpeakers;
        followedSpeakers = followedSpeakers.filter(save => save.id !== this.magidShiur.id);
        this.$store.dispatch('profile/loadFollowingSpeakers', followedSpeakers);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bio-component {
  background: $light-blue;
}
</style>
